import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=611e30af&scoped=true"
import script from "./Insurance.vue?vue&type=script&lang=js"
export * from "./Insurance.vue?vue&type=script&lang=js"
import style0 from "./Insurance.vue?vue&type=style&index=0&id=611e30af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611e30af",
  null
  
)

export default component.exports